<template>
  <div id="page-wrapper">
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content container ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix">
            <div id="main" class="container-fluid">
              <div class="row row-offcanvas row-offcanvas-left clearfix">
                <main class="main-content col content-full-width" id="content" role="main">
                  <section id="userlist-manager" class="section">
                    <div class="container-fluid">
                      <div class="row mb-15">
                        <div id="vitamins" class="col-md-12">
                          <div class="col-card mh">
                            <button class="btn-enlarge">
                              <i class="fas fa-expand"></i>
                            </button>
                            <button class="btn-minimize">
                              <i class="fas fa-compress"></i>
                            </button>
                            <h2>{{ $t('message.user_details') }}</h2>
                            <user-form :userObj="user"></user-form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

  import Header from "../Header";
  import Nav from "../Nav";
  // import axios from "../../axios-auth";
  import Userform from "./Userform";

  export default {
    components: {
      userForm:Userform,
      appHeader: Header,
      appNavbar: Nav
    },
    // created() {
    //   this.getUser()
    // },
    methods: {
      getUser() {
        this.axios.get('/users/me').then(users => users.data)
          .then(res => {
            const data = res;
            this.user = data;
          //  console.log(this.user)
          })
      }
    },
    data() {
      return {
        user: {}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/User.vue